import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'
export default {
  getSalesAmount (getType) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Analytics/sales-amount',
        { getType: getType },
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getSalesMall (getType) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Analytics/sales-mall',
        { getType: getType },
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getSalesRanking (getType) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Analytics/sales-ranking',
        { getType: getType },
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getSalesTotal () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Analytics/sales-total',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getSalesDetailMonth (getType) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Analytics/sales-detail-month',
        { getType: getType },
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getSalesOrderQuantityAndAccessViewCount (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Analytics/sales-order-quantity-and-access-view-count',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getProductAnalysisUrl (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Analytics/get-product-analysis-url',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/analyticsservice.js